// extracted by mini-css-extract-plugin
export default {"button":"ButtonBack_button__85X30","button__icon":"ButtonBack_button__icon__seDGw"};